import * as React from 'react';
import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/authorCard.svg?inline';

/**
 * The block takes no inputs on purpose. The author is read from the page's own
 * author reference, so the editor only decides where the card is placed.
 */
export type AuthorCardComponentProps = Record<string, never>;

const register = (Component: React.FC): void => {
	Builder.registerComponent(Component, {
		name: 'AuthorCard',
		image,
		inputs: [],
	});
};

export default register;
